<template>
  <div class="finance">
    <div class="serch">
      <ul>
        <li
          v-for="item in serchFields"
          v-if="item.field !== '顾问' || (user.角色 && user.角色.includes('管理员'))"
          :key="item.field"
        >
          <span>{{ item.field }}</span>
          <el-input
            v-if="item.type === 'input'"
            v-model="serchKey[item.field]"
            style="width:183px"
            size="mini"
            @keyup.enter.native="loadData"
          ></el-input>
          <el-select
            v-else
            v-model="serchKey[item.field]"
            size="mini"
            placeholder
            filterable
            @keyup.enter.native="loadData"
          >
            <el-option v-for="item in serchOption[item.field]" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </li>
        <li class="radio-group" style="width: 610px;">
          <span>状态：</span>
          <el-radio-group v-model="serchKey.状态">
            <el-radio v-for="item in status" :key="item" :label="item">{{ item }}</el-radio>
          </el-radio-group>
        </li>
        <li>
          <div class="radish-btn radish-btn-primary radish-btn-small" style="margin-left: 10px;" @click="loadData">
            搜索
          </div>
          <div class="radish-btn radish-btn-primary radish-btn-small" style="margin-left: 10px;" @click="clearSerch">
            清空
          </div>
          <!-- <el-button type="primary" size="mini" @click="loadData" style="margin-left: 10px;">搜索</el-button>
          <el-button type="primary" size="mini" @click="clearSerch" style="margin-left: 10px;">清空</el-button> -->
        </li>
      </ul>
    </div>
    <div>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="save">保存</div>
      <!-- <el-button type="primary" @click="save" size="mini" plain>保存</el-button> -->
    </div>
    <el-alert title="所有比例均为百分制" type="warning"></el-alert>
    <el-alert
      title="如果修改了客户公司及人选信息，请及时保存，否则可能会影响到某些字段的校验"
      type="warning"
    ></el-alert>
    <el-table
      size="mini"
      border
      :data="tableData"
      style="width: 100%"
      :height="listheight"
      highlight-current-row
      :default-sort="{ prop: '序号', order: 'ascending' }"
      @sort-change="sortChange"
    >
      <el-table-column
        v-for="col in tableHead"
        :key="col.label"
        :prop="col.props"
        :label="col.label"
        sortable="custom"
        :fixed="col.props === '序号' || col.props === '候选人'"
        :width="col.width"
      >
        <template slot-scope="scope">
          <div v-if="editable[col.props]" class="input_box" @click="toedit(scope, col.props)">
            <!-- 显示类型为弹窗，编辑时不会变化 -->
            <el-tooltip
              v-if="col.inputMode === 'button' && col.props === '备注'"
              class="item"
              effect="dark"
              :content="scope.row.备注"
              placement="left"
            >
              <div class="radish-btn radish-btn-primary radish-btn-small" @click="showDialog(scope.row, col.props)">
                查看详情
              </div>
              <!-- <el-button @click="showDialog(scope.row,col.props)" size="mini" round>查看详情</el-button> -->
            </el-tooltip>
            <div
              v-else-if="col.inputMode === 'button'"
              class="radish-btn radish-btn-primary radish-btn-small"
              @click="showDialog(scope.row)"
            >
              查看详情
            </div>
            <div
              v-else-if="col.props === '到岗日期' && !scope.row.到岗日期 && scope.row.pid"
              class="radish-btn radish-btn-primary radish-btn-small"
              @click="showToworksDialog(scope.row)"
            >
              确认到岗
            </div>

            <!-- <el-button
              v-else-if="col.inputMode==='button'"
              @click="showDialog(scope.row)"
              size="mini"
              round
            >查看详情</el-button> -->
            <!-- <el-button
              v-else-if="col.props==='到岗日期'&&!scope.row.到岗日期&&scope.row.pid"
              @click="showToworksDialog(scope.row)"
              size="mini"
              round
            >确认到岗</el-button> -->
            <!-- 显示类型为普通字符串 -->
            <span
              v-else-if="isEditing !== scope.$index + col.props && col.props !== '客户公司'"
              style="margin-left: 10px"
              >{{ getDate(scope.row[col.props], col.props) }}</span
            >
            <!-- 显示类型为公司，编辑时不会变化 -->
            <span
              v-else-if="col.props === '客户公司'"
              style="margin-left: 10px"
              :class="[col.props === '客户公司' && !scope.row.check ? 'red_font' : '']"
              >{{ scope.row[col.props] }}</span
            >
            <!-- =================-->
            <!--输入类型为从下拉框中选择-->
            <el-select
              v-else-if="isEditing === scope.$index + col.props && col.inputMode === 'select'"
              v-model="selectValue"
              :allow-create="col.props !== '佣金比例'"
              filterable
              size="mini"
              @change="editEnd(scope.row, col.props, col.inputMode)"
            >
              <el-option
                v-for="item in selectOption[col.props]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- 输入为日期时 -->
            <el-date-picker
              v-else-if="isEditing === scope.$index + col.props && col.inputMode === 'date'"
              v-model="dateValue"
              type="date"
              size="mini"
              placeholder="选择日期"
              :picker-options="pickerOptions"
              @change="editEnd(scope.row, col.props, col.inputMode)"
            ></el-date-picker>
            <!-- 输入类型为数字 -->
            <el-input-number
              v-else-if="isEditing === scope.$index + col.props && col.inputMode === 'percent'"
              v-model="inputNumber"
              controls-position="right"
              :precision="2"
              :min="0"
              :max="100"
              @change="editEnd(scope.row, col.props, col.inputMode)"
            ></el-input-number>
            <!-- 输入类型为普通字符串 -->
            <el-input
              v-else-if="isEditing === scope.$index + col.props && col.inputMode === 'input'"
              v-model="scope.row[col.props]"
              v-focus
              size="mini"
              @blur="editEnd(scope.row, col.props)"
            ></el-input>
          </div>
          <div v-else @click="cancelEdit(scope, col.props)">
            <!-- 显示类型为百分比，判断是否加百分号 -->
            <span
              v-if="percentType.includes(col.props)"
              style="margin-left: 10px"
              :class="[col.props === '客户公司' && !scope.row.check ? 'red_font' : '']"
            >
              {{ scope.row[col.props] }} <span v-if="showPercent(scope.row[col.props], col.props)">%</span>
            </span>
            <div v-else-if="col.props === '角色'">
              <el-tag
                v-for="type in scope.row.角色"
                :key="type"
                style="margin:0 4px 4px 0"
                size="mini"
                type="success"
                >{{ type }}</el-tag
              >
            </div>
            <span v-else style="margin-left: 10px" @click="cancelEdit(scope, col.props)">
              {{ getDate(scope.row[col.props], col.props) }}
              <i
                v-if="col.props === '候选人'"
                class="el-icon-search"
                style="color:#1a97e2"
                @click.stop="defaultSerchRadish(scope)"
              ></i>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="company-pagination"
      :current-page="page"
      :page-sizes="[50, 100, 200, 300]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></el-pagination>
    <!-- 搜索人选弹窗 -->
    <serch-radish-dialog ref="serchRadishDialog" @choose="chooseRadish"> </serch-radish-dialog>
    <!-- 人选到岗 -->
    <toworkDialog ref="toworkDialog" :on-confirm="confirmTowork"></toworkDialog>
    <!-- 未与项目匹配搜索项目 -->
    <!-- <el-dialog :visible.sync="dialogCompanyName" width="360px" :modal="false">
      <el-alert title="这条数据未与系统数据匹配过，请搜索项目将数据进行配对" type="warning"></el-alert>
      <div class="serch-project">
        <el-input v-model="serchProjectKeyword" @keyup.enter="serchProject"></el-input>
        <el-table
          :data="serchProjectResult"
          v-loading="serchProjectLoading"
          size="mini"
          style="width: 100%"
        >
          <el-table-column prop="操作" label="操作" width="60px">
            <template slot-scope="scope">
              <span class="click-span" @click="chooseRadish(scope.row)">选择</span>
            </template>
          </el-table-column>
          <el-table-column prop="姓名" label="姓名" width="100px">
            <template slot-scope="scope">
              <div>
                <span
                  class="drawer-link"
                  @click="showRadish({id:scope.row._id })"
                >{{ scope.row.姓名 }}</span>
              </div>
              <div style="color:#aaa">{{ scope.row.手机 }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="公司" label="公司" width="100px"></el-table-column>
          <el-table-column prop="部门" label="部门" width="100px"></el-table-column>
          <el-table-column prop="目前职位" label="目前职位" width="100px"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="initChooseCompanyName">取 消</el-button>
        <el-button type="primary" @click="modifyCompanyName">确 定</el-button>
      </span>
    </el-dialog>-->
    <!-- 备注 -->
    <el-dialog :visible.sync="dialogComment" width="480px" :close-on-click-modal="false" :modal="false">
      <el-input v-model="commentValue" type="textarea" :rows="2" placeholder="请输入内容"></el-input>
      <span slot="footer" class="dialog-footer">
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="dialogComment = false">取 消</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="saveDialog">确 定</div>
        <!-- <el-button size="mini" @click="dialogComment = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="saveDialog">确 定</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>
<script>
import serchRadishDialog from './component/serchRadishDialog.vue'

export default {
  components: { serchRadishDialog },
  directives: {
    focus: {
      inserted: function(el) {
        el.querySelector('input').focus()
      },
    },
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 50,
      sort: { 年份: 1, 序号: 1, 开票批次: 1 },
      listheight: '100px',
      dateValue: '',
      commissionVisible: false,
      commissionValue: '',
      editIndex: '',
      isEditing: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            },
          },
        ],
      },
      tableData: [],
      tableHead: [
        { label: '序号', props: '序号', width: '70' },
        { label: '候选人', props: '候选人', width: '90' },
        { label: '手机号', props: '手机号', width: '130' },
        { label: '年份', props: '年份', width: '80' },
        {
          label: '职能模块',
          props: '职能模块',
          width: '130',
          inputMode: 'select',
        },
        {
          label: '目前职位',
          props: '目前职位',
          width: '150',
          inputMode: 'input',
        },
        { label: '职级', props: '职级', width: '70', inputMode: 'input' },
        {
          label: '客户公司',
          props: '客户公司',
          width: '130',
        },
        {
          label: '本次发票金额',
          props: '发票金额',
          width: '120',
        },
        {
          label: '固定年薪',
          props: '固定年薪',
          width: '100',
          inputMode: 'input',
        },
        {
          label: '佣金比例',
          props: '佣金比例',
          width: '100',
        },
        { label: '佣金额', props: '佣金额', width: '85' },
        {
          label: '开票批次',
          props: '开票批次',
          width: '100',
        },
        {
          label: '开票比例',
          props: '开票比例',
          width: '100',
        },
        {
          label: '付款通知书编号',
          props: '付款通知书编号',
          width: '130',
        },
        {
          label: '旧付款通知书编号',
          props: '旧付款通知书编号',
          width: '145',
        },
        {
          label: '此单保证期',
          props: '保证期',
          width: '110',
          inputMode: 'select',
        },

        {
          label: 'offer签订日期',
          props: 'offer签订日期',
          width: '120',
          inputMode: 'date',
        },

        {
          label: '预计到岗日期',
          props: '预计到岗日期',
          width: '120',
          inputMode: 'date',
        },
        {
          label: '到岗日期',
          props: '到岗日期',
          width: '100',
          inputMode: 'date',
        },
        {
          label: '开票主体',
          props: '开具发票',
          width: '120',
        },
        {
          label: '发票寄出日期',
          props: '发票寄出日期',
          width: '120',
          inputMode: 'date',
        },
        {
          label: '回款日期',
          props: '回款日期',
          width: '100',
        },
        { label: 'OFFER', props: 'offer', width: '110' },
        { label: '角色', props: '角色', width: '110', inputMode: 'array' },
        {
          label: '业绩分成',
          props: '业绩分成',
          width: '110',
          inputMode: 'percent',
        },
        { label: '业绩', props: '业绩', width: '110', inputMode: 'string' },
        {
          label: '提成比例',
          props: '提成比例',
          width: '110',
          inputMode: 'percent',
        },
        { label: '提成', props: '提成', width: '110', inputMode: 'string' },
        {
          label: '备注',
          props: '备注',
          width: '100',
          inputMode: 'button',
        },
      ],
      editable: {
        年份: false,
        序号: false,
        职能模块: true,
        目前职位: true,
        职级: true,
        客户公司: false,
        候选人: false,
        发票金额: false,
        固定年薪: true,
        佣金比例: false,
        佣金额: false,
        开票批次: false,
        开票比例: false,
        到岗日期: true,
        预计到岗日期: true,
        付款通知书编号: false,
        旧付款通知书编号: false,
        开具发票: false,
        发票寄出日期: true,
        回款日期: false,
        保证期: true,
        offer: false,
        角色: false,
        业绩分成: false,
        业绩: false,
        提成比例: false,
        提成: false,
        offer签订日期: false,
        备注: true,
      },
      inputNumber: '',
      selectValue: '',
      selectOption: {
        职能模块: [],
        保证期: [{ label: '三个月', value: '三个月' }, { label: '六个月', value: '六个月' }],
      },
      percentType: ['佣金比例', '开票比例', '提成比例', '业绩分成', '提成比例'],
      dialogIndex: '',
      serchRadishKeywords: '',
      serchFields: [
        { field: '客户公司', type: 'input' },
        { field: '候选人', type: 'input' },
        { field: '手机号', type: 'input' },
        { field: '年份', type: 'select' },
        { field: '职能模块', type: 'select' },
        { field: '顾问', type: 'select' },
      ],
      serchOption: {
        年份: ['2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020'],
        职能模块: [],
        顾问: [],
        顾问: [],
      },
      status: ['所有', 'offer未到岗', '到岗未开票', '已开票未回款', '已回款'],
      serchKey: {
        客户公司: '',
        候选人: '',
        手机号: '',
        年份: '',
        职能模块: '',
        顾问: '',
        状态: '',
      },
      dialogComment: false,
      commentValue: '',
      confirmToworkRow: '',
    }
  },
  computed: {
    user() {
      return app.user
    },
  },
  async mounted() {
    this.loadData()
    this.setOption()
  },
  created() {
    this.listheight = window.innerHeight - 278
  },
  methods: {
    showToworksDialog(row) {
      if (row.pid && row.rid) {
        // 弹出确认到岗通知框
        this.confirmToworkRow = row
        this.$refs.toworkDialog.show({ rid: row.rid, 姓名: row.候选人 }, row.pid)
      } else {
        // 弹出搜索项目选择
        this.$message('该数据未与项目绑定')
      }
    },
    confirmTowork() {
      this.isEditing = ''
      this.loadData()
    },
    clearSerch() {
      for (const key in this.serchKey) {
        this.serchKey[key] = ''
      }
      this.sort = { 年份: 1, 序号: 1, 开票批次: 1 }
      this.loadData()
    },
    chooseRadish(radish) {
      const row = this.tableData[this.editIndex]
      const indexArr = this.getSameProjectIndex(this.editIndex)
      indexArr.forEach((val, index) => {
        this.tableData[val].候选人 = radish.姓名
        this.tableData[val].手机号 = radish.手机
      })
    },
    async defaultSerchRadish({ row, column, $index }) {
      this.editIndex = this.findRowById(row._id)
      this.$refs.serchRadishDialog.open({ 姓名: row.候选人, 手机: row.手机号 })
    },
    showRadish(opts) {
      window.open(`${window.frontend}/#/radish-detail-blank/${opts.id}`, '_blank')
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    // 检查该字段是否需要显示百分号
    showPercent(val, key) {
      const hasValue = val
      const isPercent = this.percentType.includes(key)
      const onlyNumber = /^[0-9]*$/.test(val)
      if (hasValue && isPercent && onlyNumber) {
        return true
      } else {
        return false
      }
    },
    // 将日期显示为2000/01/01格式
    getDate(val, key) {
      const dateType = ['offer签订日期', '预计到岗日期', '到岗日期', '发票寄出日期', '回款日期']
      if (dateType.includes(key) && val) {
        return this.timestampToDate(val)
      } else {
        return val
      }
    },
    timestampToDate(timestemp) {
      const year = new Date(timestemp).getFullYear()
      const month = new Date(timestemp).getMonth() + 1
      const data = new Date(timestemp).getDate()
      return `${year}/${month}/${data}`
    },
    toedit({ row, column, $index }, props) {
      this.editIndex = this.findRowById(row._id)
      this.isEditing = $index + props
      this.selectValue = row[props]
      this.inputNumber = row[props]
      this.dateValue = row[props]
    },
    // 计算所有需要计算的字段的函数
    computeMoney(index) {
      const row = this.tableData[index]
      const salary = this.stringToNumber(row.固定年薪)
      const commissionRate = this.stringToNumber(row.佣金比例)
      const invoiceRate = this.stringToNumber(row.开票比例)
      let commission = this.stringToNumber(row.佣金额)
      if (salary !== 0 && commissionRate !== '') {
        commission = salary * commissionRate * 0.01
        this.tableData[index].佣金额 = commission
      }
      if (commission !== 0 && invoiceRate !== '') {
        this.tableData[index].发票金额 = commission * invoiceRate * 0.01
        this.computeCommission(index)
      }
    },
    computeCommission(index) {
      const row = this.tableData[index]
      if (row.业绩分成) {
        row.业绩 = this.stringToNumber(row.发票金额) * this.stringToNumber(row.业绩分成) * 0.01
        if (row.提成比例) {
          row.提成 = this.stringToNumber(row.业绩) * this.stringToNumber(row.提成比例) * 0.94 * 0.01
        }
      }
    },
    stringToNumber(str) {
      const onlyNumber = /^[0-9]*$/
      if (str && typeof str === 'string' && onlyNumber.test(str)) {
        return parseFloat(str)
      } else if (str && typeof str === 'number') {
        return str
      } else {
        return 0
      }
    },
    findRowById(id) {
      let index
      this.tableData.forEach((val, ind) => {
        if (val._id === id) {
          index = ind
        }
      })
      return index
    },
    editEnd(row, type, inputMode) {
      const index = this.findRowById(row._id)
      const item = this.tableData[index]
      if (inputMode === 'percent') {
        this.tableData[index][type] = this.inputNumber
      } else if (inputMode === 'select') {
        this.tableData[index][type] = this.selectValue
      } else if (inputMode === 'date') {
        this.tableData[index][type] = new Date(this.dateValue).getTime()
      }
      this.syncChange(index, type)
      this.isEditing = ''
    },
    syncChange(index, key) {
      const notSyncKey = ['开票批次', '开票比例', '发票金额', '发票寄出日期', '回款日期']
      if (!notSyncKey.includes(key)) {
        const toChangeIndex = this.getSameProjectIndex(index)
        toChangeIndex.forEach(ind => {
          if (ind !== index) {
            this.tableData[ind][key] = this.tableData[index][key]
          }
          this.computeMoney(ind)
        })
      }
    },
    getSameProjectIndex(index) {
      const result = [index]
      const changeitem = this.tableData[index]
      const checkfield = ['客户公司', '候选人', '手机号']
      this.tableData.map((item, mapindex) => {
        const notsame = mapindex !== index
        let valsame = true
        checkfield.map(key => {
          if (changeitem[key] !== item[key]) {
            valsame = false
          }
        })
        if (notsame && valsame) {
          result.push(mapindex)
        }
      })
      return result
    },
    cancelEdit() {
      this.isEditing = ''
    },
    showDialog(row) {
      const index = this.findRowById(row._id)
      this.dialogIndex = index
      this.dialogComment = true
      this.commentValue = this.tableData[index].备注
    },
    saveDialog() {
      this.dialogComment = false
      this.tableData[this.dialogIndex].备注 = this.commentValue
      this.syncChange(this.dialogIndex, '备注')
    },
    async setOption() {
      const notshow = ['admin', 'test', 'wpgao', 'cctang', 'test1', 'yezuochang', 'hktang']
      // const showAccount = app.accounts.filter(val => {
      //   return !notshow.includes(val)
      // })
      let showAccount
      if (app.user.角色 && app.user.角色.includes('管理员')) {
        if (!app.accounts) {
          await app.getUsers()
        }
        showAccount = app.accounts.filter(val => !notshow.includes(val))
      } else if (app.user.角色 && app.user.角色.includes('团队长')) {
        showAccount = app.user.队员 ? app.user.队员.split(';') : [app.user.account]
      } else showAccount = [app.user.account]
      if (!app.categories) {
        await app.getCats()
      }
      this.serchOption.顾问 = showAccount
      this.serchOption.顾问 = showAccount
      this.serchOption.职能模块 = app.categories.map(category => category.名称)

      this.selectOption.职能模块 = app.categories.map(category => ({ label: category.名称, value: category.名称 }))
      this.selectOption.顾问 = showAccount.map(account => ({ label: account, value: account }))
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    sortChange(data) {
      const fields = ['年份', '序号', '开票批次']
      const key = data.prop
      const value = data.order === 'descending' ? -1 : 1
      if (fields.includes(key)) {
        this.sort[key] = value
      } else {
        const oldsort = this.sort
        const newsort = { [key]: value }
        fields.forEach(field => {
          newsort[field] = oldsort[field]
        })
        this.sort = newsort
      }
      this.loadData()
    },
    async save() {
      const result = await window.app.service('company').saveAccountFinance(this.tableData)
      if (result.status === 200) {
        this.$message('保存成功')
        // this.changeIndex = []
        this.loadData()
      } else {
        this.$message('保存失败，请稍后重试')
      }
    },
    async loadData() {
      if (this.user.角色 && !this.user.角色.includes('管理员')) this.serchKey.顾问 = this.user.account
      const option = {
        page: this.page,
        pageSize: this.pageSize,
        sort: this.sort,
        query: this.serchKey,
      }
      try {
        const { data, page, pageSize, total } = await window.app.service('company').getAccountFinance(option)
        this.tableData = data
        this.page !== page && (this.page = page)
        this.pageSize !== pageSize && (this.pageSize = pageSize)
        this.total !== total && (this.total = total)
      } catch (error) {
        this.$message(error.message)
      }
    },
  },
}
</script>
<style>
.hidden-select .el-input__suffix {
  display: none;
}
.hidden-select input.el-input__inner {
  padding-right: 0;
}
</style>
<style src="../statistics/css/finance.css" scoped></style>
